import {HttpErrorResponse} from '@angular/common/http';

export const STANDARD_ASSIGNMENT_ERROR = {
  inherited: 'INHERITED_STANDARD_READONLY',
  conflict: 'STANDARD_EMPLOYEE_OVERRIDE_CONFLICT',
  cleanup: 'STANDARD_ASSIGNMENT_CLEANUP_PENDING',
  selection: 'STANDARD_ASSIGNMENT_ALL_EMPLOYEES_WITH_POSITIONS'
};
export const STANDARD_ASSIGNMENT_ERROR_KEY = {
  inherited: 'STANDARD_ASSIGNMENT_INHERITED_READONLY',
  conflict: 'STANDARD_ASSIGNMENT_CONFLICT',
  cleanup: 'STANDARD_ASSIGNMENT_CLEANUP_PENDING',
  access: 'STANDARD_ASSIGNMENT_CLEANUP_ACCESS_LOST',
  selection: 'STANDARD_ASSIGNMENT_ALL_EMPLOYEES_WITH_POSITIONS'
};
const HTTP_CONFLICT = 409;
const HTTP_UNPROCESSABLE = 422;
const HTTP_PRECONDITION_FAILED = 412;
const STRING_TYPE = 'string';
const EMPTY_ERROR_CODE = '';

interface StandardAssignmentErrorBody { errorCode?: string; reason?: string; message?: string; }

export function standardAssignmentErrorCode(error: HttpErrorResponse): string {
  if (!error || ![HTTP_CONFLICT, HTTP_UNPROCESSABLE, HTTP_PRECONDITION_FAILED].includes(error.status)) { return EMPTY_ERROR_CODE; }
  const body = assignmentErrorBody(error.error);
  const candidates = [body.errorCode, body.reason, body.message, error.statusText, error.error];
  return Object.keys(STANDARD_ASSIGNMENT_ERROR).map(key => STANDARD_ASSIGNMENT_ERROR[key])
    .find(code => candidates.some(candidate => candidate === code)) || EMPTY_ERROR_CODE;
}

function assignmentErrorBody(body: StandardAssignmentErrorBody | string): StandardAssignmentErrorBody {
  if (typeof body !== STRING_TYPE) { return body as StandardAssignmentErrorBody || {}; }
  try { return JSON.parse(body as string) || {}; } catch (error) { return {}; }
}

export function standardAssignmentErrorKey(error: HttpErrorResponse): string {
  const code = standardAssignmentErrorCode(error);
  const name = Object.keys(STANDARD_ASSIGNMENT_ERROR).find(key => STANDARD_ASSIGNMENT_ERROR[key] === code);
  return name ? STANDARD_ASSIGNMENT_ERROR_KEY[name] : EMPTY_ERROR_CODE;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/standard-assignment-error.ts